import { AntenaCrudPage } from 'app/antena/antena/pages/AntenaCrudPage';
import { AntenaGrupoCrudPage } from 'app/antena/grupo/pages/AntenaGrupoCrudPage';
import EventoCreatePage from 'app/eventos/pages/EventoCreatePage';
import EventoDetailPage from 'app/eventos/pages/EventoDetailPage';
import EventosListPage from 'app/eventos/pages/EventosListPage';
import BillerCrudPage from 'app/biller/pages/BillerCrudPage';
import { DriverIncomePage } from 'app/chofer/income/pages/DriverIncomePage';
import ChoferCrudPage from 'app/chofer/pages/ChoferCrudPage';
import ChoferProfilePage from 'app/chofer/pages/ChoferProfilePage';
import DriverShiftsPage from 'app/chofer/pages/DriverShiftsPage';
import { DriverSettlementDetailPage } from 'app/chofer/settlements/pages/DriverSettlementDetailPage';
import { DriverSettlementsCreatePage } from 'app/chofer/settlements/pages/DriverSettlementsCreatePage';
import { DriverSettlementsPage } from 'app/chofer/settlements/pages/DriverSettlementsPage';
import { DriverTransferReservationPendingSettlement } from 'app/chofer/settlements/pages/DriverTransferReservationPendingSettlement';
import { DriverExpirationPage } from 'app/chofer/vencimientos/pages/DriverExpirationPage';
import ClientBusinessCrudPage from 'app/client/clientBusiness/pages/ClientBusinessCrudPage';
import ClientBusinessProfilePage from 'app/client/clientBusiness/pages/ClientBusinessProfilePage';
import RateCrudPage from 'app/client/clientBusiness/rates/pages/RateCrudPage';
import { ClientPrivateCrudPage } from 'app/client/private/private/pages/ClientPrivateCrudPage';
import { ClientPrivateRatePage } from 'app/client/private/rates/pages/ClientPrivateRatePage';
import FacturadosPage from 'app/facturas/pages/FacturadosPage';
import TollCrudPage from 'app/Toll/pages/TollCrudPage';
import { UserCrudPage } from 'app/user/pages/UserCrudPage';
import VehiculoFabricanteCrudPage from 'app/vehiculos/fabricanteVehiculo/pages/VehiculoFabricanteCrudPage';
import VehiculoModeloCrudPage from 'app/vehiculos/modeloVehiculo/pages/VehiculoModeloCrudPage';
import VehiculoCrudPage from 'app/vehiculos/pages/VehiculoCrudPage';
import VehiculoProfilePage from 'app/vehiculos/pages/VehiculoProfilePage';
import TitularCrudPage from 'app/vehiculos/titulares/pages/TitularCrudPage';
import ViajeTrasladoOpenedPage from 'app/viaje/viajeTraslado/abierto/pages/ViajeTrasladoOpenedPage';
import ViajeTrasladoGestionPage from 'app/viaje/viajeTraslado/gestion/pages/ViajeTrasladoGestionPage';
import { TransferReservationClientBusinessToValidateModifyPage } from 'app/viaje/viajeTraslado/pendienteValidacion/pages/TransferReservationClientBusinessToValidateModifyPage';
import { TransferReservationClientPrivateToValidateModifyPage } from 'app/viaje/viajeTraslado/pendienteValidacion/pages/TransferReservationClientPrivateToValidateModifyPage';
import { TransferReservationToValidateCountProvider } from 'app/viaje/viajeTraslado/pendienteValidacion/context/TransferReservationToValidateCountContext';
import { ViajePendienteSolicitadoPage } from 'app/viaje/viajeTraslado/pendienteValidacion/pages/ViajePendienteSolicitadoPage';
import { TransferReservationPrivateBatchPage } from 'app/viaje/viajeTraslado/private/pages/TransferReservationPrivateBatchPage';
import { TransferReservationPrivateCopyPage } from 'app/viaje/viajeTraslado/private/pages/TransferReservationPrivateCopyPage';
import { TransferReservationPrivateModifyPage } from 'app/viaje/viajeTraslado/private/pages/TransferReservationPrivateModifyPage';
import { TransferReservationRepetitivePage } from 'app/viaje/viajeTraslado/repetitive/pages/TransferReservationRepetitivePage';
import { TransferReservationRepetitivePrivatePage } from 'app/viaje/viajeTraslado/repetitivePrivate/pages/TransferReservationRepetitivePrivatePage';
import { AnalisisComercialPage } from 'app/viaje/viajeTraslado/statistics/pages/AnalisisComercialPage';
import { AverageSpentPerClient } from 'app/viaje/viajeTraslado/statistics/pages/AverageSpentPerClientPage';
import { ManualAndAutomaticReservationsPerMonth } from 'app/viaje/viajeTraslado/statistics/pages/ManualAndAutomaticReservationsPerMonthPage';
import { PricePerClientPage } from 'app/viaje/viajeTraslado/statistics/pages/PricePerClientPage';
import { ReservationPricePerClient } from 'app/viaje/viajeTraslado/statistics/pages/ReservationPricePerClientPage';
import { ReservationAmountPerClient } from 'app/viaje/viajeTraslado/statistics/pages/ReservationsPerClientPage';
import { TransferReservationAssignedPerDayPage } from 'app/viaje/viajeTraslado/statistics/pages/TransferReservationAssignedPerDayPage';
import { TransferReservationDriverResumeTablePage } from 'app/viaje/viajeTraslado/statistics/pages/TransferReservationDriverResumeTablePage';
import { TransferReservationPerCoordinatorPage } from 'app/viaje/viajeTraslado/statistics/pages/TransferReservationPerCoordinatorPage';
import { TransferReservationPerDayPage } from 'app/viaje/viajeTraslado/statistics/pages/TransferReservationPerDayPage';
import { TransferReservationPeroOperatorAndClientPage } from 'app/viaje/viajeTraslado/statistics/pages/TransferReservationPeroOperatorAndClientPage';
import { TransferReservationPerOperatorPage } from 'app/viaje/viajeTraslado/statistics/pages/TransferReservationPerOperatorPage';

import { CoordinadorChoferPendingSettlement } from 'app/chofer/settlements/pages/CoordinadorChoferPendingSettlement';
import ViajeTrasladoCorreccionContado from 'app/viaje/viajeTraslado/pendienteAuditoria/pages/ViajeTrasladoCorreccionContado';
import { ViajeTrasladoPendienteAuditoriaContadoPage } from 'app/viaje/viajeTraslado/pendienteAuditoria/pages/ViajeTrasladoPendienteAuditoriaContadoPage';
import { TransferReservationClientBulkTripCreation } from 'app/viaje/viajeTraslado/viajeTraslado/pages/TransferReservationClientBulkTripCreation';
import { TransferReservationClientBusinessBatchPage } from 'app/viaje/viajeTraslado/viajeTraslado/pages/TransferReservationClientBusinessBatchPage';
import { TransferReservationClientBusinessCopyPage } from 'app/viaje/viajeTraslado/viajeTraslado/pages/TransferReservationClientBusinessCopyPage';
import { TransferReservationClientBusinessModifyPage } from 'app/viaje/viajeTraslado/viajeTraslado/pages/TransferReservationClientBusinessModifyPage';
import { TransferReservationSingleStoreProvider } from 'app/viaje/viajeTraslado/viajeTraslado/services/TransferReservationSingleStore';
import CrudExample from 'example/pages/CrudExample';
import FormExamplePage from 'forms/pages/FormExamplePage';
import FormSteppersPage from 'forms/pages/FormSteppersPage';
import Header from 'layout/components/Header';
import Sidebar, { SideBarStatus } from 'layout/components/Sidebar/Sidebar';
import ProfilePage from 'profile/pages/ProfilePage';
import React, { useCallback, useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { useResponsiveBreakpoint } from 'shared/hooks';
import LiquidacionesPage from '../../app/liquidaciones/pages/LiquidacionesPage';
import ViajeTrasladoDeletePage from '../../app/viaje/viajeTraslado/gestion/pages/ViajeTrasladoDeletePage';
import ViajeTrasladoCorreccionCuantaCoriente from '../../app/viaje/viajeTraslado/pendienteAuditoria/pages/ViajeTrasladoCorrecionCuentaCorriente';
import ViajeTrasladoPendienteAuditoriaPage from '../../app/viaje/viajeTraslado/pendienteAuditoria/pages/ViajeTrasladoPendienteAuditoriaPage';
import ViajeTrasladoPendienteLiquidacionPage from '../../app/viaje/viajeTraslado/pendienteLiquidacion/pages/ViajeTrasladoPendienteLiquidacionPage';
import { ViajeTrasladoDetailPage } from '../../app/viaje/viajeTraslado/viajeTraslado/pages/ViajeTrasladoDetailPage';
import Landing from './Landing';
import ViajeTrasladoCoordinarPage from 'app/viaje/viajeTraslado/coordinar/pages/ViajeTrasladoCoordinarPage';
import ViajeTrasladoBorradoresPage from 'app/viaje/viajeTraslado/borradores/pages/ViajeTrasladoBorradoresPage';
import { NotificationsProvider } from 'shared/context/notificationContext';
import AppUsers from 'app/client/appUsers/pages/AppUsers';
import ViajeTrasladoCanceladosPage from 'app/viaje/viajeTraslado/cancelados/pages/ViajeTrasladoCancelados';
import { useTravelsCanceled } from 'app/viaje/viajeTraslado/cancelados/hooks/useTravelsCanceled';
import AppUsersEdit from 'app/client/appUsers/pages/AppUsersEdit';
import DiscountsPage from 'app/discounts/pages/DiscountsPage';
import DiscountEditPage from 'app/discounts/pages/DiscountEditPage';
import AppPaymentsPage from 'app/viaje/viajeTraslado/particular/pages/AppPaymentsPage';
import { saveLastPath } from 'app/viaje/viajeTraslado/viajeTraslado/utils/lastpagevisited';
import TrafficLightRulesConfigurationItemPage from 'app/traffic-lights-management/TrafficLightRulesConfigurationItemPage';
import TrafficLightRulesConfigurationPage from 'app/traffic-lights-management/TrafficLightRulesConfigurationPage';
import AppUserRatings from 'app/client/appUserRatings/pages/AppUserRatings';
import ContingenciesControlPage from 'app/contingencies/pages/ContingenciesControlPage';

const MainLayout = () => {
  const breakpoint = useResponsiveBreakpoint();
  const location = useLocation();

  useEffect(() => {
    saveLastPath(location.pathname + location.search);
  }, [location.pathname]);

  const [sidebarStatus, setSidebarStatus] = useState<SideBarStatus>({
    platform: 'desktop',
    status: 'collapsed'
  });

  const {
    travels,
    countTravels,
    getAllTravelsCanceled,
    markTravelCancelCheck,
    highlightedId
  } = useTravelsCanceled();

  const onMarkTravelCancelCheck = useCallback(
    async (id: number) => {
      const response = await markTravelCancelCheck(id);
      return response;
    },
    [markTravelCancelCheck]
  );

  useEffect(() => {
    getAllTravelsCanceled();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (breakpoint === 'xs') {
      setSidebarStatus({ platform: 'mobile', status: 'closed' });
    }
    if (breakpoint === 'sm') {
      setSidebarStatus({ platform: 'desktop', status: 'collapsed' });
    }
  }, [breakpoint]);

  function dismissVisibleSidebar() {
    if (sidebarStatus.platform === 'mobile') {
      setSidebarStatus({ platform: 'mobile', status: 'closed' });
    }
  }

  function toggleCollapse() {
    if ((sidebarStatus.platform = 'desktop')) {
      setSidebarStatus((status) =>
        status.status === 'expanded'
          ? { platform: 'desktop', status: 'collapsed' }
          : { platform: 'desktop', status: 'expanded' }
      );
    }
  }

  return (
    <TransferReservationToValidateCountProvider>
      <div className="flex h-screen overflow-hidden">
        <Sidebar
          status={sidebarStatus}
          toggleCollapse={toggleCollapse}
          totalCancelTrips={countTravels}
        />
        <div className="flex flex-1 flex-col overflow-hidden">
          <div
            className="flex-1 overflow-auto"
            onClick={dismissVisibleSidebar}
            style={{
              backgroundColor:
                sidebarStatus.platform === 'mobile' ? 'white' : '#eaedf5'
            }}
          >
            <div className="lg:hidden">
              <Header
                toggleSidebar={(
                  e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                ) => {
                  setSidebarStatus({ platform: 'mobile', status: 'open' });
                  e.stopPropagation();
                }}
              />
            </div>
            <div className="bg-blueGray-100"></div>
            <Switch>
              <Route path="/main/landing">
                <Landing />
              </Route>
              <Route path="/main/example">
                <CrudExample />
              </Route>
              <Route path="/main/profile">
                <ProfilePage />
              </Route>
              <Route path="/main/forms/form">
                <FormExamplePage />
              </Route>
              <Route path="/main/forms/steppers">
                <FormSteppersPage />
              </Route>
              <Route path="/main/operations/gdf/drivers/:id">
                <ChoferProfilePage />
              </Route>
              <Route path="/main/operations/gdf/drivers">
                <ChoferCrudPage />
              </Route>
              <Route path="/main/operations/driver-operational-information/driver-averages">
                <DriverIncomePage />
              </Route>
              <Route path="/main/administration/driver-settlements/settle-fortnight-drivers-to-settle">
                <DriverSettlementsCreatePage />
              </Route>
              <Route path="/main/administration/driver-settlements/history/:id">
                <DriverSettlementDetailPage asRole="admin" />
              </Route>
              <Route path="/main/administration/driver-settlements/history">
                <DriverSettlementsPage asRole="admin" />
              </Route>
              <Route path="/main/driver/me/travels-pending-settlement">
                <DriverTransferReservationPendingSettlement />
              </Route>
              <Route path="/main/inventories/liquidation-control">
                <CoordinadorChoferPendingSettlement />
              </Route>
              <Route path="/main/driver/me/settlements/:id">
                <DriverSettlementDetailPage asRole="driver" />
              </Route>
              <Route path="/main/driver/me/settlements">
                <DriverSettlementsPage asRole="driver" />
              </Route>

              <Route path="/main/operations/gdf/vehicle-management/vehicles/:id">
                <VehiculoProfilePage />
              </Route>

              <Route path="/main/operations/gdf/vehicle-management/vehicles">
                <VehiculoCrudPage />
              </Route>
              <Route path="/main/operations/gdf/vehicle-management/titulares">
                <TitularCrudPage />
              </Route>
              <Route path="/main/operations/gdf/vehicle-management/producer">
                <VehiculoFabricanteCrudPage />
              </Route>
              <Route path="/main/operations/gdf/vehicle-management/models">
                <VehiculoModeloCrudPage />
              </Route>
              <Route path="/main/inventories/discounts/:id">
                <DiscountEditPage />
              </Route>
              <Route path="/main/inventories/discounts">
                <DiscountsPage />
              </Route>
              <Route path="/main/administration/appPayments">
                <AppPaymentsPage />
              </Route>
              <Route path="/main/operations/gdf/billers">
                <BillerCrudPage />
              </Route>
              <Route path="/main/commercial/management-client/business/:clientBusinessId/rates">
                <RateCrudPage />
              </Route>
              <Route path="/main/commercial/management-client/business/:id">
                <ClientBusinessProfilePage />
              </Route>
              <Route path="/main/commercial/management-client/business">
                <ClientBusinessCrudPage />
              </Route>
              <Route path="/main/clientParticular/listado">
                <ClientPrivateCrudPage />
              </Route>
              <Route path="/main/commercial/rate-management/rate">
                <ClientPrivateRatePage />
              </Route>
              <Route path="/main/inventories/appUsers/:id">
                <AppUsersEdit />
              </Route>
              <Route path="/main/inventories/appUsers">
                <AppUsers />
              </Route>
              <Route path="/main/commercial/app-ratings">
                <AppUserRatings />
              </Route>
              <Route path="/main/shifts">
                <DriverShiftsPage />
              </Route>
              <Route path="/main/tolls-management">
                <TollCrudPage />
              </Route>
              <Route path="/main/inventories/users">
                <UserCrudPage />
              </Route>
              <Route path="/main/inventories/contingencies-control">
                <ContingenciesControlPage />
              </Route>
              <Route path="/main/inventories/antenna-management/antenna">
                <AntenaCrudPage />
              </Route>
              <Route path="/main/inventories/antenna-management/groups">
                <AntenaGrupoCrudPage />
              </Route>
              <Route path="/main/inventories/events/create">
                <EventoCreatePage />
              </Route>
              <Route path="/main/inventories/events/:id">
                <EventoDetailPage />
              </Route>
              <Route path="/main/inventories/events">
                <EventosListPage />
              </Route>
              <TransferReservationSingleStoreProvider>
                <Route path="/main/operations/cdr/create-corporate" exact>
                  <TransferReservationClientBusinessBatchPage />
                </Route>
                <Route path="/main/operations/cdr/create-corporate/:id" exact>
                  <TransferReservationClientBusinessBatchPage isDraftPage />
                </Route>
                <Route path="/main/operations/cdr/bot-drafts">
                  <ViajeTrasladoBorradoresPage />
                </Route>
                <Route path="/main/operations/cdr/bulk-upload">
                  <TransferReservationClientBulkTripCreation />
                </Route>
                {/* <Route path="/main/Viaje/traslado/pendiente" exact>
                <ViajeTrasladoPendientesPage />
              </Route> */}
                <NotificationsProvider>
                  <Route path="/main/operations/coordination/pending-trips" exact>
                    <ViajeTrasladoCoordinarPage />
                  </Route>
                  <Route path="/main/operations/coordination/open-trips">
                    <ViajeTrasladoOpenedPage />
                  </Route>
                </NotificationsProvider>
                <Route
                  path="/main/operations/cdr/app-cancelled"
                  exact
                >
                  <ViajeTrasladoCanceladosPage
                    onMarkTravelCancelCheck={onMarkTravelCancelCheck}
                    travels={travels}
                    highlightedId={highlightedId}
                  />
                </Route>
                {/* <Route path="/main/Viaje/traslado/mapa">
                <ViajeTrasladoMapPage />
              </Route> */}
                <Route path="/main/operations/modify-private/:id">
                  <TransferReservationPrivateModifyPage />
                </Route>
                <Route path="/main/operations/copy-private/:id">
                  <TransferReservationPrivateCopyPage />
                </Route>
                <Route path="/main/operations/cdr/recurring-particular">
                  <TransferReservationRepetitivePrivatePage />
                </Route>
                <Route path="/main/operations/cdr/create-particular">
                  <TransferReservationPrivateBatchPage />
                </Route>
                <Route path="/main/Viaje/traslado/abierto">
                  <ViajeTrasladoOpenedPage />
                </Route>
                <Route path="/main/administration/billing-travel-review/corporate-audit">
                  <ViajeTrasladoPendienteAuditoriaPage />
                </Route>
                <Route path="/main/Viaje/traslado/pendiente-auditoria-contado">
                  <ViajeTrasladoPendienteAuditoriaContadoPage />
                </Route>
                <Route path="/main/administration/fix-billing/fix-corporate">
                  <ViajeTrasladoCorreccionCuantaCoriente />
                </Route>
                <Route path="/main/administration/fix-billing/fix-particular">
                  <ViajeTrasladoCorreccionContado />
                </Route>
                <Route path="/main/administration/billing/pending-corporate-settlements">
                  <ViajeTrasladoPendienteLiquidacionPage />
                </Route>

                <Route path="/main/administration/billing/corporate-settlements">
                  <LiquidacionesPage />
                </Route>

                <Route path="/main/administration/billing/billed-corporate-services">
                  <FacturadosPage />
                </Route>

                <Route path="/main/operations/gdf/fleet-expirations">
                  <DriverExpirationPage />
                </Route>
                <Route path="/main/operations/cdr/app-validation/client-business/:id">
                  <TransferReservationClientBusinessToValidateModifyPage />
                </Route>
                <Route path="/main/operations/cdr/app-validation/client-particular/:id">
                  <TransferReservationClientPrivateToValidateModifyPage />
                </Route>
                <Route path="/main/operations/cdr/app-validation">
                  <ViajePendienteSolicitadoPage />
                </Route>
                <Route path="/main/operations/cdr/comprehensive-management">
                  <ViajeTrasladoGestionPage />
                </Route>
                <Route path="/main/operations/delete-reservation">
                  <ViajeTrasladoDeletePage />
                </Route>
                <Route path="/main/operations/trip-details/:id">
                  <ViajeTrasladoDetailPage />
                </Route>
                <Route path="/main/operations/copy-corporate">
                  <TransferReservationClientBusinessCopyPage />
                </Route>
                <Route path="/main/operations/modify-corporate">
                  <TransferReservationClientBusinessModifyPage />
                </Route>
                <Route path="/main/operations/cdr/recurring-corporate">
                  <TransferReservationRepetitivePage />
                </Route>
                <Route path="/main/statistics/bookings-per-agent">
                  <TransferReservationPerOperatorPage />
                </Route>
                <Route path="/main/statistics/daily-bookings">
                  <TransferReservationPerDayPage />
                </Route>
                <Route path="/main/statistics/driver-performance">
                  <TransferReservationDriverResumeTablePage />
                </Route>
                <Route path="/main/statistics/assigned-by-coordinator">
                  <TransferReservationPerCoordinatorPage />
                </Route>
                <Route path="/main/statistics/assigned-per-day">
                  <TransferReservationAssignedPerDayPage />
                </Route>
                <Route path="/main/statistics/per-operator-and-client">
                  <TransferReservationPeroOperatorAndClientPage />
                </Route>
                <Route path="/main/statistics/average-value-per-trip">
                  <ReservationPricePerClient />
                </Route>
                <Route path="/main/statistics/average-spent-per-client">
                  <AverageSpentPerClient />
                </Route>
                <Route path="/main/statistics/customer-ranking">
                  <ReservationAmountPerClient />
                </Route>
                <Route path="/main/statistics/price-per-client">
                  <PricePerClientPage />
                </Route>

                <Route path="/main/statistics/audited-services">
                  <ManualAndAutomaticReservationsPerMonth />
                </Route>
                <Route path="/main/statistics/analisis-comercial">
                  <AnalisisComercialPage />
                </Route>
                {/* readOnly opcional en la query: ?readOnly=true (no va en el path) */}
                <Route
                  exact
                  path="/main/inventories/traffic-lights-management/traffic-light-rules-configuration/:id"
                >
                  <TrafficLightRulesConfigurationItemPage />
                </Route>
                <Route
                  exact
                  path="/main/inventories/traffic-lights-management/traffic-light-rules-configuration"
                >
                  <TrafficLightRulesConfigurationPage />
                </Route>
              </TransferReservationSingleStoreProvider>
            </Switch>
          </div>
        </div>
      </div>
    </TransferReservationToValidateCountProvider>
  );
};
export default MainLayout;
